export const APPLICATION_VERSION = process.env.VERSION;
export const APPLICATION_PHASE = process.env.APPLICATION_PHASE || 'REAL';

export const RTMP_URL = process.env.RTMP_URL;

export const PAGINATION = {
    first: true,
    last: false,
    numberOfElements: 10,
    size: 10,
    number: 1,
    totalPages: 1,
    totalElements: 1
};

/** 너무 세분화하지 말고 HEADER 를 구분하는 정도
 *  default :: json string
 'Access-Control-Allow-Origin': '*',
 'Access-Control-Allow-Methods': 'GET,POST,PUT,DELETE,OPTIONS'
 */
export const DEFAULT_HEADER = {
    'Content-Type': 'application/json'
};
/*
export const FIELD_PAGE = 'page';
export const FIELD_SIZE = 'size';
*/

/* component별 사이즈 정리 */
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_ROUTE = '/';

export const MEMBER_ID = 'memberId';
export const NAME = 'name';
export const CONSTRUCTION_NM = 'constructionNm';
export const CONSTRUCTION = 'construction';
export const TYPE = 'type';

export const AUTO_YN = 'autoYn';

/* APP 관련 */
export const PICTURE_SORCE_TYPE = {
    PHOTOLIBRARY: 0,
    CAMERA: 1
};

export const PICTURE_MEDIA_TYPE = {
    PICTURE: 0,
    VIDEO: 1
};

/*
Cordova 관련 설정
*/
export const CORDOVA_SRC = 'cordova.js';

/*
Device 관련 설정
*/

/*
평문전송을 위한 암호 key
*/
export const SECRET_KEY = 'dwcdslivea111111111111';
